// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Ok-z","red":"Pk-z","calloutlink":"Qk-z","headerTopBanner":"Rk-z","bgcolorRed":"Sk-z","headerTopCallout":"Tk-z","searchBanner":"Uk-z","hideMobile":"Vk-z"};